import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IrisProgressBarComponent } from './progress-bar.component';

@NgModule({
  declarations: [IrisProgressBarComponent],
  imports: [CommonModule],
  exports: [IrisProgressBarComponent],
  providers: []
})
export class IrisProgressBarModule {}
